import styled, { css } from 'styled-components'
import { mobileBreakpoint, tabletBreakpoint } from 'react-components'
import { getBasePath } from '../../../../../utils/miscellaneous-utils'

const BG_IMAGE = getBasePath('/assets/images/background/hidden-gem-bg-pattern.jpg')

export const CarouselWrapper = styled.div`
    position: relative;
    margin: 1.5rem 0;
    width: 100%;
    background-image: url(${BG_IMAGE});
    background-repeat: repeat;
    border-radius: 1.5rem;
    padding: 0.5rem 0 1rem 1rem;

    @media (max-width: ${tabletBreakpoint.max}px) {
        border-radius: 0;
        margin-left: -1rem;
        margin-right: -1rem;
        width: auto;
    }
`

export const CarouselHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding-right: 1rem;
    margin-bottom: 0.5rem;
`

export const CarouselIcon = styled.img`
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    margin-top: 0.5rem;

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        margin-top: 0rem;
    }
`

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    margin: 0.75rem 0 0.25rem;
`

export const Heading = styled.h3(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 1.5625rem;
        font-weight: 600;
        line-height: 1.875rem;
        margin: 0;
        color: #282828;

        @media only screen and (max-width: ${mobileBreakpoint.max}px) {
            font-size: 1.25rem;
            line-height: 1.75rem;
        }
    `,
)

export const HeadingPrimary = styled.span`
    color: #866800;
    margin-right: 0.25rem;
`

export const SubHeading = styled.p`
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    margin: 0;
    color: #6c6c6c;

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        display: none;
    }
`

export const SliderContainer = styled.div`
    position: relative;
    margin-right: 1rem;
`

export const SkeletonRow = styled.div`
    display: flex;
    gap: 0.75rem;
    margin-right: 0.5rem;

    @media (max-width: ${tabletBreakpoint.max}px) {
        gap: 0.5rem;
    }

    > * {
        flex: 1;
        min-width: 0;
    }
`

export const SlideInner = styled.div`
    height: 100%;
    box-sizing: border-box;
`
